import { FullScreen } from "~/components/screens/FullScreen"

export default function Page() {
	return (
		<FullScreen
			title="Authorization Error"
			message="You do not have permission to access this resource. Please contact your administrator if you think this is a mistake."
		/>
	)
}
